module.exports = __webpack_public_path__ + "img/s2-1-s.51ab7c56.svg";